import React from "react";
import { cn } from "@/lib/utils";
import { formatMinorCurrency } from "@/utils/billingBalance";

interface AmountCellProps {
  amount?: number;
  currency?: string;
  className?: string;
}

export const AmountCell: React.FC<AmountCellProps> = ({
  amount = 0,
  currency = "USD",
  className,
}) => {
  if (amount === 0) {
    return null;
  }

  return (
    <div className={cn("text-center", className)}>
      <span
        className={cn(
          "inline-flex min-h-5 items-center justify-center rounded-full px-1.5 py-0.5 text-[10px]",
          {
            "text-red-600": amount < 0,
            "text-green-600": amount > 0,
          },
        )}
      >
        {amount > 0 ? "+" : ""}
        {formatMinorCurrency(amount, currency)}
      </span>
    </div>
  );
};
